import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class OrganizationProSkillManagerInfoModel extends Model {
  constructor(
    public name: string | null = null,
    public count: number = 0,
  ) {
    super();
  }

  public static create(model: Partial<OrganizationProSkillManagerInfoModel>): OrganizationProSkillManagerInfoModel {
    return createModel<OrganizationProSkillManagerInfoModel>(OrganizationProSkillManagerInfoModel, {
      ...model
    });
  }
}
